import React from 'react';
import { TrustBadge } from '../components/TrustBadge';
import { TargetIcon, ZapIcon, ShieldIcon } from 'lucide-react';
export function About() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-slate-50" data-id="element-124">
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-125">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8" data-id="element-126">
          About Us
        </h1>

        {/* Mission */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8" data-id="element-127">
          <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-128">
            Our Mission
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed mb-6" data-id="element-129">
            At Domisafe, our goal is to make everyday work faster, clearer and
            more organised with simple subscription-based software. We believe
            that managing tasks, customer information and team communication
            shouldn't require complicated systems or lengthy training.
          </p>
          <p className="text-lg text-slate-600 leading-relaxed mb-6" data-id="element-130">
            We're committed to transparency, ease of use and reliability. Every
            feature we build is designed to save you time and reduce complexity,
            so you can focus on what matters most—running your business
            effectively.
          </p>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-131">
            Whether you're a small team or a growing company, Domisafe provides
            the tools you need to stay organised, communicate clearly and keep
            your customer information secure and accessible.
          </p>
        </div>

        {/* Our Service */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8" data-id="element-132">
          <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-133">
            Our Service
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed mb-6" data-id="element-134">
            Domisafe provides cloud-based tools for managing customer
            information, sending updates, tracking tasks and monitoring
            performance. Everything runs in your browser—no downloads, no
            installation, no technical setup required.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8" data-id="element-135">
            <div className="text-center" data-id="element-136">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-137">
                <TargetIcon className="w-8 h-8 text-emerald-600" data-id="element-138" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2" data-id="element-139">
                Clear & Simple
              </h3>
              <p className="text-slate-600 text-sm" data-id="element-140">
                Intuitive interface that anyone can use from day one
              </p>
            </div>

            <div className="text-center" data-id="element-141">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-142">
                <ZapIcon className="w-8 h-8 text-emerald-600" data-id="element-143" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2" data-id="element-144">
                Fast & Reliable
              </h3>
              <p className="text-slate-600 text-sm" data-id="element-145">
                Cloud-based platform that's always available when you need it
              </p>
            </div>

            <div className="text-center" data-id="element-146">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-147">
                <ShieldIcon className="w-8 h-8 text-emerald-600" data-id="element-148" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2" data-id="element-149">
                Secure & Transparent
              </h3>
              <p className="text-slate-600 text-sm" data-id="element-150">
                Your data is protected with clear, honest pricing
              </p>
            </div>
          </div>
        </div>

        {/* Reviews */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8" data-id="element-151">
          <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-152">
            What Our Customers Say
          </h2>

          <div className="space-y-6" data-id="element-153">
            <div className="border-l-4 border-emerald-500 pl-6 py-2" data-id="element-154">
              <p className="text-lg text-slate-700 italic mb-2" data-id="element-155">
                "Brilliant same-day response."
              </p>
              <p className="text-sm font-semibold text-slate-900" data-id="element-156">
                – J. Turner
              </p>
            </div>

            <div className="border-l-4 border-emerald-500 pl-6 py-2" data-id="element-157">
              <p className="text-lg text-slate-700 italic mb-2" data-id="element-158">
                "Clear pricing and tidy work."
              </p>
              <p className="text-sm font-semibold text-slate-900" data-id="element-159">– A. Patel</p>
            </div>

            <div className="border-l-4 border-emerald-500 pl-6 py-2" data-id="element-160">
              <p className="text-lg text-slate-700 italic mb-2" data-id="element-161">
                "Set our system up in minutes."
              </p>
              <p className="text-sm font-semibold text-slate-900" data-id="element-162">
                – S. Bennett
              </p>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap gap-6 justify-center" data-id="element-163">
          <TrustBadge icon="location" text="UK-Based" data-id="element-164" />
          <TrustBadge icon="payment" text="Secure Payments" data-id="element-165" />
          <TrustBadge icon="star" text="Trusted Service" data-id="element-166" />
          <TrustBadge icon="shield" text="Clear Pricing" data-id="element-167" />
        </div>
      </section>
    </div>;
}